<script lang="ts">
    import { getCachedEntries } from "../../../api"
    import { onChange } from "../../components/formComponents/helper"
    import Input from "../../components/formComponents/Input.svelte"
    import { copyObject } from "../utils"
    import Images from "./Images.svelte"

    export let field: TaskStepField<"usageAmountObjects">,
        value: Usages[] = []
    if (!Array.isArray(value)) value = []
    let options: Option[] = []
    let valueStorage: OptionValueStorage[] = []
    let additionalMaterials: OptionValueStorage[] = []

    interface OptionValueStorage extends Usages {
        active: boolean
    }

    // Fetch options and initialize valueStorage and additionalMaterials
    getCachedEntries("option", {
        category: "utillityMaterial",
    }).then((optionObjs) => {
        const valueCopy: Usages[] = copyObject(value)
        options = optionObjs

        // Initialize valueStorage with matching options
        valueStorage = options.map((option) => {
            let existingValueIndex = (valueCopy || []).findIndex((val) => val.name === option.name)
            if (existingValueIndex !== -1) {
                return {
                    ...valueCopy[existingValueIndex],
                    active: valueCopy[existingValueIndex]?.active !== false,
                }
            }
            return {
                name: option.name,
                amount: null,
                unit: option.additionalInfos.unit,
                materialImageIds: [],
                active: false,
            }
        })

        // Initialize additionalMaterials with non-matching options from value
        value.forEach((material) => {
            if (!options.find((option) => option.name === material.name)) {
                additionalMaterials.push({
                    ...material,
                    active: true,
                })
            }
        })

        if (additionalMaterials.length === 0) {
            addEmptyAdditionalMaterial()
        }
        additionalMaterials = additionalMaterials
    })

    function additionalMaterialIsValid(material: OptionValueStorage) {
        return material.name || material.amount || material.unit || material.materialImageIds?.length
    }

    function addEmptyAdditionalMaterial() {
        additionalMaterials.push({
            name: "",
            amount: null,
            unit: "",
            materialImageIds: [],
            active: false,
        })
    }

    function removeEmptyAdditionalMaterials() {
        additionalMaterials = additionalMaterials.filter((material) => additionalMaterialIsValid(material))
    }

    // Reactive block to update and clean additionalMaterials
    $: {
        if (valueStorage.length) {
            removeEmptyAdditionalMaterials()

            if (
                additionalMaterials.length === 0 ||
                additionalMaterialIsValid(additionalMaterials[additionalMaterials.length - 1])
            ) {
                addEmptyAdditionalMaterial()
            }

            const newValue = [
                ...copyObject(valueStorage.filter((val) => val.active || val.amount || val.materialImageIds.length)),
                ...copyObject(additionalMaterials.filter((material) => additionalMaterialIsValid(material))),
            ]

            // Update the value with newValue
            if (JSON.stringify(newValue) !== JSON.stringify(value)) {
                value = newValue
            }
        }
    }
</script>

<div class="usagesWrapper form">
    <h2>Eingesetztes Material</h2>
    <ul class="objects">
        {#each valueStorage as val, i}
            <li class="grid">
                <div class="col-6">
                    <Input
                        id="{val.name}"
                        bind:value="{valueStorage[i].amount}"
                        type="checkboxInputNumber"
                        placeholder="{val.name}"
                        onChange="{onChange}"
                        unit="{val.unit}"
                    />
                </div>
                <div class="col-6 field-image[]">
                    <Images
                        bind:value="{valueStorage[i].materialImageIds}"
                        field="{{
                            widget: 'image[]',
                        }}"
                    />
                </div>
            </li>
        {/each}
        {#each additionalMaterials as additionalMaterial, i}
            <li class="grid">
                <div class="col-3">
                    <Input
                        id="additionalMaterial-{i}"
                        bind:value="{additionalMaterials[i].name}"
                        type="checkboxInput"
                        placeholder="Sonst. Material"
                        onChange="{onChange}"
                        unit="{additionalMaterials[i].unit.toLowerCase()}"
                    />
                </div>
                <div class="col-3">
                    <Input
                        id="additionalMaterialAmount-{i}"
                        bind:value="{additionalMaterials[i].amount}"
                        type="number"
                        placeholder="Menge"
                        onChange="{onChange}"
                    />
                </div>
                <div class="col-3">
                    <Input
                        id="additionalMaterialUnit-{i}"
                        bind:value="{additionalMaterials[i].unit}"
                        type="text"
                        placeholder="Einheit"
                        onChange="{onChange}"
                    />
                </div>
                <div class="col-3 field-image[]">
                    <Images
                        bind:value="{additionalMaterials[i].materialImageIds}"
                        field="{{
                            widget: 'image[]',
                        }}"
                    />
                </div>
            </li>
        {/each}
    </ul>
</div>

<style lang="less">
    .usagesWrapper {
        display: flex;
        flex-direction: column;
        gap: 1.2rem;
        .objects {
            display: flex;
            flex-direction: column;
            gap: 0.6rem;
            li {
            }
        }
    }
</style>
